import { OpcionSelect } from 'src/components/input/TextInput';
import * as Yup from 'yup';


export const esquemaDeValidacionNuevoUsuarioUnidad = Yup.object({
  usuarioId: Yup.string().required("El usuario es obligatorio"),
  unidadId: Yup.string().required("La unidad es obligatoria"),
  correoProceso: Yup.string().email("El correo no es válido"),

});

export const setValoresInicialesUsuarioUnidad = (valores: IdocumentosForm) => {
  return {
    certificadoRnmcAdjuntoId: valores.certificadoRnmcAdjuntoId,
    certificadoPoliciaNacionalAdjuntoId: valores.certificadoPoliciaNacionalAdjuntoId,
    certificadoProcuraduriaAdjuntoId: valores.certificadoProcuraduriaAdjuntoId,
    certificadoContraloriaAdjuntoId: valores.certificadoContraloriaAdjuntoId,
    tarjetaProfesionalAdjuntoId: valores.tarjetaProfesionalAdjuntoId,
    documentoIdentidadAdjuntoId: valores.documentoIdentidadAdjuntoId,
    certificadoRnmcAdjuntoFecha: valores.certificadoRnmcAdjuntoFecha,
    certificadoPoliciaNacionalAdjuntoFecha: valores.certificadoPoliciaNacionalAdjuntoFecha,
    certificadoProcuraduriaAdjuntoFecha: valores.certificadoProcuraduriaAdjuntoFecha,
    certificadoContraloriaAdjuntoFecha: valores.certificadoContraloriaAdjuntoFecha,
    tarjetaProfesionalAdjuntoFecha: valores.tarjetaProfesionalAdjuntoFecha,
    documentoIdentidadAdjuntoFecha: valores.documentoIdentidadAdjuntoFecha,
    hojaDeVidaAdjuntoId: valores.hojaDeVidaAdjuntoId,
    certificadoAntecedentesDisciplinariosId: valores.certificadoAntecedentesDisciplinariosId,
    certificadoAntecedentesDisciplinariosFecha: valores.certificadoAntecedentesDisciplinariosFecha,
  }
}

export const valoresInicialesDocumentos: IdocumentosForm = {
  certificadoRnmcAdjuntoId: '',
  certificadoPoliciaNacionalAdjuntoId: '',
  certificadoProcuraduriaAdjuntoId: '',
  certificadoContraloriaAdjuntoId: '',
  tarjetaProfesionalAdjuntoId: '',
  documentoIdentidadAdjuntoId: '',
  certificadoRnmcAdjuntoFecha: '',
  certificadoPoliciaNacionalAdjuntoFecha: '',
  certificadoProcuraduriaAdjuntoFecha: '',
  certificadoContraloriaAdjuntoFecha: '',
  tarjetaProfesionalAdjuntoFecha: '',
  documentoIdentidadAdjuntoFecha: '',
  hojaDeVidaAdjuntoId: '',
  certificadoAntecedentesDisciplinariosId: '',
  certificadoAntecedentesDisciplinariosFecha: '',
}

export interface FormacionAcademica {
  nombreTituloObtenido: string,
  nombreInstitucion: string,
  fechaGraduacion: string,
  soporteId: string

}

export interface IdocumentosForm {
  hojaDeVidaAdjuntoId: string,
  certificadoRnmcAdjuntoId: string,
  certificadoPoliciaNacionalAdjuntoId: string,
  certificadoProcuraduriaAdjuntoId: string,
  certificadoContraloriaAdjuntoId: string,
  tarjetaProfesionalAdjuntoId: string,
  documentoIdentidadAdjuntoId: string,
  certificadoAntecedentesDisciplinariosId: string,
  certificadoAntecedentesDisciplinariosFecha: string,
  certificadoRnmcAdjuntoFecha: string,
  certificadoPoliciaNacionalAdjuntoFecha: string,
  certificadoProcuraduriaAdjuntoFecha: string,
  certificadoContraloriaAdjuntoFecha: string,
  tarjetaProfesionalAdjuntoFecha: string,
  documentoIdentidadAdjuntoFecha: string,
}

// Buscar persona STEP
export interface IbuscarPersonaForm {
  tipoIdentificacion: string,
  identificacion: string,
  tipoPersona: string,
}

export const valoresInicialesBuscarPersona: IbuscarPersonaForm = {
  tipoIdentificacion: "",
  identificacion: "",
  tipoPersona: "NATURAL",
};

export const esquemaDeValidacionDocumentos = Yup.object({
  hojaDeVidaAdjuntoId: Yup.string().required("El documento es obligatorio"),
  certificadoRnmcAdjuntoId: Yup.string().required("El certificado es obligatorio"),
  certificadoPoliciaNacionalAdjuntoId: Yup.string().required("El certificado es obligatorio"),
  certificadoProcuraduriaAdjuntoId: Yup.string().required("El certificado es obligatorio"),
  certificadoContraloriaAdjuntoId: Yup.string().required("El certificado es obligatorio"),
  documentoIdentidadAdjuntoId: Yup.string().required("El certificado es obligatorio"),
  // solo fecha de los ultimos 30 dias
  certificadoRnmcAdjuntoFecha: Yup.date().required("La fecha es obligatoria").max(new Date(), "La fecha no puede ser mayor a la fecha actual").min(new Date(new Date().setDate(new Date().getDate() - 30)), "La fecha no puede ser mayor a 30 días"),
  certificadoPoliciaNacionalAdjuntoFecha: Yup.date().required("La fecha es obligatoria").max(new Date(), "La fecha no puede ser mayor a la fecha actual").min(new Date(new Date().setDate(new Date().getDate() - 30)), "La fecha no puede ser mayor a 30 días"),
  certificadoProcuraduriaAdjuntoFecha: Yup.date().required("La fecha es obligatoria").max(new Date(), "La fecha no puede ser mayor a la fecha actual").min(new Date(new Date().setDate(new Date().getDate() - 30)), "La fecha no puede ser mayor a 30 días"),
  certificadoContraloriaAdjuntoFecha: Yup.date().required("La fecha es obligatoria").max(new Date(), "La fecha no puede ser mayor a la fecha actual").min(new Date(new Date().setDate(new Date().getDate() - 30)), "La fecha no puede ser mayor a 30 días"),
});

export const opcionesTipoIdentificacionPersonaNatural: OpcionSelect[] = [
  { valor: 'AS', label: 'Adulto sin identificación' },
  { valor: 'CC', label: 'Cédula de ciudadanía' },
  { valor: 'CD', label: 'Carné diplomático' },
  { valor: 'CE', label: 'Cédula de extranjería' },
  { valor: 'CN', label: 'Certificado de nacionalidad' },
  { valor: 'DE', label: 'Documento de identificación extranjero' },
  { valor: 'MS', label: 'Menor sin identificación' },
  { valor: 'NI', label: 'Número de identificación' },
  { valor: 'NV', label: 'Número de identificación de extranjero' },
  { valor: 'PA', label: 'Pasaporte' },
  { valor: 'PE', label: 'Permiso especial de permanencia' },
  { valor: 'PT', label: 'Permiso de trabajo' },
  { valor: 'RC', label: 'Registro civil' },
  { valor: 'SC', label: 'Salvoconducto de menor' },
  { valor: 'SI', label: 'SIN identificación' },
  { valor: 'TI', label: 'Tarjeta de identidad' },
];

export const opcionesSexo: OpcionSelect[] = [
  { valor: 'AS', label: 'Masculino' },
  { valor: 'CC', label: 'Femenino' },
  { valor: 'CD', label: 'Prefiero no decir' },
];